import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import {
  resolveEventWallTimezone,
  scheduleInputToEventWallMinute,
} from "./eventWallMinuteStrings";

dayjs.extend(utc);
dayjs.extend(timezone);

function normalizedWallsForLabels(
  start: string,
  end: string,
  eventTimezone: string
): { tz: string; wallStart: string; wallEnd: string } | null {
  if (!start || !end) return null;
  const tz = resolveEventWallTimezone(eventTimezone);
  const wallStart = scheduleInputToEventWallMinute(start, eventTimezone);
  const wallEnd = scheduleInputToEventWallMinute(end, eventTimezone);
  if (!wallStart || !wallEnd) return null;
  return { tz, wallStart, wallEnd };
}

/** Review row: format campaign schedule wall range with timezone label. */
export function formatCampaignScheduleWallRange(
  start: string,
  end: string,
  eventTimezone: string
): string {
  const walls = normalizedWallsForLabels(start, end, eventTimezone);
  if (!walls) return "—";
  const { tz, wallStart, wallEnd } = walls;
  const fmt = (wall: string) => {
    const d = dayjs.tz(wall.slice(0, 16), tz);
    if (!d.isValid()) return wall;
    return d.format(d.minute() === 0 ? "MMM D 'YY ha" : "MMM D 'YY h:mma");
  };
  const tzShort = tz.replace(/_/g, " ");
  return `${fmt(wallStart)} – ${fmt(wallEnd)} (${tzShort})`;
}

/**
 * Scheduled budget phase line on campaign review: wall times in the event zone, e.g.
 * `Mar 30 12:00am → Apr 2 7:00pm` (no campaign-range timezone suffix).
 */
export function formatScheduledPhaseWallRange(
  start: string,
  end: string,
  eventTimezone: string
): string {
  const walls = normalizedWallsForLabels(start, end, eventTimezone);
  if (!walls) return "—";
  const { tz, wallStart, wallEnd } = walls;
  const fmt = (wall: string) => {
    const d = dayjs.tz(wall.slice(0, 16), tz);
    if (!d.isValid()) return wall;
    return d.format("MMM D h:mma");
  };
  return `${fmt(wallStart)} → ${fmt(wallEnd)}`;
}
